<template>
  <div class="bort-info" :id="'obj-info-' + bort.id_stand" style="visibility: visible" :class="{ active: true }">
    <div style="margin-right: 0px">
      <table>
        <tr>
          <th><b>Рейс:</b></th>
          <td><b>{{ bort.FlightInfo.NR }}</b></td>
        </tr>
        <tr>
          <th><b>Стоянка:</b></th>
          <td>{{ bort.FlightInfo.Stand }}</td>
        </tr>
        <tr>
          <th><b>Борт. номер:</b></th>
          <td>{{ bort.FlightInfo.Bort }}</td>
        </tr>
        <tr>
          <th><b>Тип ВС:</b></th>
          <td>{{ bort.FlightInfo.Type }}</td>
        </tr>
        <tr>
          <th><b>Макс. взл. масса:</b></th>
          <td>{{ bort.FlightInfo.MTOW }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bortInfo',
  props: {
    bort: {
      type: Object,
      // Для объектов или массивов значения по умолчанию
      // должны возвращаться из функции
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.bort-info {
  display: flex;
  background: #fff;
  opacity: 1;
  top: 0;
  left: 0;
  color: #494963;
  width: auto;
  padding: 8px 6px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 1.6;
}

th {
  padding: 0px 2px;
  min-width: 100px;
  white-space: nowrap;
  vertical-align: top;
  line-height: 15px;
  text-align: left;
}

td {
  white-space: nowrap;
  padding: 0px 2px;
  min-width: 70px;
  vertical-align: top;
  line-height: 15px;
}

tr {
  margin-top: 5px;
}

</style>
